module.exports = "/static/media/device-backgroundBlank.0ff29386.png";